export default {"src":"/_next/static/media/check.01583f56.svg","height":10,"width":10};